<style type="text/css">
  .v-menu__content--fixed {
    top: 62px !important;
  }
</style>

<template>
  <v-card class="overflow-hidden">
    <v-app-bar app class="header-box">
      <v-toolbar-title>
        <v-img
          max-height="58"
          max-width="218"
          :src="logo_image"
          :lazy-src="logo_image"
        >
        </v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="user-profilebox">
        <v-img
          class="elevation-6"
          alt=""
           :src="require('@/assets/images/admin-icon.png')"
          id="profile_pic2"
        >
        </v-img>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="dropdown-btnbox"
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              <v-img
                max-height="18"
                max-width="18"
                :src="require('@/assets/images/blue-dropdown.png')"
              >
              </v-img>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title
                ><v-btn @click="logout">Logout</v-btn></v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </v-btn>
    </v-app-bar>
  </v-card>

</template>

<script>
import { Auth } from "aws-amplify";
import {
  GET_PROFILE_DETAIL,
  GET_REFERRAL_DETAIL,
  USER_SIGNOUT,
  USER_DETAILS,
} from "../../store/actions.type";
import { isEmpty } from "lodash";
import JwtService from ".././common/jwt.service";
export default {
  data: () => ({
    isAddClassMainBox: true,
    logo_image: process.env.VUE_APP_ROOT_ICONS_URL + "Logo.png",
  }),
  mounted() {
    
    // setTimeout(()=>{
    //   this.isFreeTrail = localStorage.getItem("isFreeTrail");
    //   this.deductionPercentage = localStorage.getItem("deductionPercentage");
    //   this.freeTrialOver = parseInt(localStorage.getItem("freeTrialOver"));
    // },4000);
  },

  methods: {
    logout(evt) {
      // return;
      this.saveEmail = JwtService.getAdminEmail();
      evt.preventDefault();
      swal.fire({
        title: 'Are you sure want to Logout?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#F19700',
        cancelButtonColor: '#b8b4ad',
        confirmButtonText: 'Yes'
      })
      .then((result) => {
        if (result.isConfirmed) {
          localStorage.clear()
          this.$router.push({ name: "LoginLayout" }).catch(() => {});
        }
      });
    },
  },
};
</script>